import React from "react";

export default function Terms() {
    return (
        <div className="p-8 text-gray-800">
        <h2 className="text-3xl font-bold mb-4">1. Introduzione</h2>
        <div className="text-black font-normal mb-6">
          <p>Benvenuto nel nostro sito. I seguenti termini di servizio disciplinano l'uso del nostro sito web e dei servizi offerti. Accedendo o utilizzando il sito, accetti questi termini.</p>
        </div>
      
        <h2 className="text-3xl font-bold mb-4">2. Accettazione dei Termini</h2>
        <div className="text-black font-normal mb-6">
          <p>Utilizzando il nostro sito, accetti di rispettare tutti i termini e le condizioni previsti in questo accordo.</p>
        </div>
      
        <h2 className="text-3xl font-bold mb-4">3. Descrizione del Servizio</h2>
        <div className="text-black font-normal mb-6">
          <p>Offriamo una piattaforma per gestire il servizio clienti, che consente agli utenti di contattarci.</p>
        </div>
      
        <h2 className="text-3xl font-bold mb-4">4. Obblighi dell'utente</h2>
        <div className="text-black font-normal mb-6">
          <p>L'utente si impegna a utilizzare il nostro sito e i nostri servizi in modo conforme alle leggi applicabili, e a non violare i diritti di proprietà intellettuale di terzi.</p>
        </div>
      
        <h2 className="text-3xl font-bold mb-4">5. Limitazioni di Responsabilità</h2>
        <div className="text-black font-normal mb-6">
          <p>Non siamo responsabili per danni diretti, indiretti, incidentali o consequenziali derivanti dall'uso del sito.</p>
        </div>
      
        <h2 className="text-3xl font-bold mb-4">6. Modifiche ai Termini</h2>
        <div className="text-black font-normal mb-6">
          <p>Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con una data di aggiornamento.</p>
        </div>
      
        <h2 className="text-3xl font-bold mb-4">7. Legge Applicabile</h2>
        <div className="text-black font-normal mb-6">
          <p>Questi termini sono regolati dalla legge italiana. In caso di controversie, la giurisdizione competente sarà Il Tribunale di Spoleto.</p>
        </div>
      </div>
      
    );
  }